/**
 * Format number as currency with South African Rand formatting
 * Example: 1500000 => "1,500,000.00"
 */
export const formatCurrency = (value: number): string => {
  return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/**
 * Parse currency string to number
 * Example: "R 1,500,000.00" => 1500000
 */
export const parseCurrency = (value: string): number => {
  return parseFloat(value.replace(/[R,\s]/g, '')) || 0;
};

/**
 * Format number as percentage
 * Example: 0.15 => "15.00%"
 */
export const formatPercentage = (value: number): string => {
  return `${(value * 100).toFixed(2)}%`;
};
